import { LpComparisonTable } from "routes/LandingPage/components/LpComparisonTable";
import { LpCtaForm } from "routes/LandingPage/components/LpCtaForm";
import { LpFaq } from "routes/LandingPage/components/LpFaq";
import { LpFeatures } from "routes/LandingPage/components/LpFeatures";
import { LpFloatingCta } from "routes/LandingPage/components/LpFloatingCta";
import { LpFooter } from "routes/LandingPage/components/LpFooter";
import { LpHero } from "routes/LandingPage/components/LpHero";
import { LpImpact } from "routes/LandingPage/components/LpImpact";
import { LpLogoBand } from "routes/LandingPage/components/LpLogoBand";
import { LpMeta } from "routes/LandingPage/components/LpMeta";
import { LpNavbar } from "routes/LandingPage/components/LpNavbar";
import { LpOnboarding } from "routes/LandingPage/components/LpOnboarding";
import { LpPricing } from "routes/LandingPage/components/LpPricing";
import { LpProblem } from "routes/LandingPage/components/LpProblem";
import { LpRoiCalculator } from "routes/LandingPage/components/LpRoiCalculator";
import { LpSecurity } from "routes/LandingPage/components/LpSecurity";
import { LpSolution } from "routes/LandingPage/components/LpSolution";
import { LpTestimonials } from "routes/LandingPage/components/LpTestimonials";
import {
  type LpConfigContextValue,
  LpConfigProvider,
} from "routes/LandingPage/LpConfigContext";
import { lpConfig } from "routes/LandingPage/lpConfig";
import "./lp.css";

const SEARCH_LP: LpConfigContextValue = { page: "search", config: lpConfig };

/**
 * StrixSearch ランディングページ（検索 LP）
 * @return {JSX.Element} LPページ全体
 */
const LandingPage = () => {
  return (
    <LpConfigProvider value={SEARCH_LP}>
      <div className="lp-page min-h-screen bg-white text-[#0F1649] overflow-x-hidden">
        <LpMeta />

        <LpNavbar />
        <main>
          <LpHero />
          <LpLogoBand />
          <LpProblem />
          <LpSolution />
          <LpFeatures />
          <LpSecurity />
          <LpImpact />
          <LpRoiCalculator />
          <LpTestimonials />
          <LpComparisonTable />
          <LpPricing />
          <LpOnboarding />
          <LpFaq />
          <LpCtaForm />
        </main>
        <LpFooter />

        {/* Floating Mobile CTA */}
        <LpFloatingCta />
      </div>
    </LpConfigProvider>
  );
};

export default LandingPage;
